import { scriptRequire } from "@/utils/scripts";
import { tr } from "@/utils/translations";
import { Analytics, AnalyticsVendor } from "./v4_analytics";


class MatomoAnalytics implements Analytics {
    /**
     * initialize the analytics call chain.
     */
    async initialize() {
        let _paq = (window as any)._paq = (window as any)._paq || [];

        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        let url = "//stats.ticketmachine.de/";
        _paq.push(['setTrackerUrl', url+'matomo.php']);
        _paq.push(['setSiteId', '1']);

        await scriptRequire(url + "matomo.js");
    }

    /**
     * Record the event
     */
    async event() {
    }

    /**
     * This may reload it.
     */
    async close() {
        window.location.reload();
    }
}


const MATOMO: AnalyticsVendor = {
    id: "system:matomo",

    strictlyRequired: false,
    inInitialActivations: false,

    describe: () => ({
        name: tr("cookie-law.vendors.systems.matomo.name"),
        description: tr("cookie-law.vendors.systems.matomo.description"),

        actualFeatures: [3],
        actualSpecialFeatures: [2],

        actualPurposes: [10],
        actualSpecialPurposes: [],

        policyUrl: "/privacy",
        deviceDisclosureUrl: null,
    }),
    build() {
        return new MatomoAnalytics();
    }

};
export default MATOMO;
